const DefaultTextField = ({ field, value, onChange, loading }) => {
  const { name, label } = field;

  return (
    <input
      type="text"
      name={name}
      placeholder={label}
      value={value ?? ''}
      onChange={onChange}
      disabled={loading}
      className="px-3 py-2 border rounded disabled:opacity-50 disabled:cursor-not-allowed w-full"
    />
  );
};

export default DefaultTextField;
